var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.scaleFactTemplate,{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],tag:"component",attrs:{"data":_vm.mediumFactValue,"disabled":_vm.disabled},on:{"change":_vm.saveMediumFact}})}
var staticRenderFns = []

export { render, staticRenderFns }